<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <span>Заголовок * (<TranslationIcon />)</span>
        <v-text-field
          outlined
          :disabled="isLoading"
          :loading="isLoading"
          :value="listItem.data.title"
          :error-messages="returnAddressError"
          @input="mixChangeListItemHandler($event, 'title')"
        />
      </v-col>
    </v-row>
    <v-row>
      <QuillEditorVue
        :cols="12"
        :content="listItem.data.description"
        :loading="isLoading"
        :disabled="isLoading"
        light-mode
        @input="mixChangeListItemHandler($event, 'description')"
        @onChangeContent="$emit('change:descriptionForMobile', $event)"
      />
    </v-row>
    <v-col cols="12">
      <MediaFilePicker
        label="Изображения"
        :file-type="$options.mediaTypesByKeys.IMAGE"
        :value="listItem.data.images"
        @change="mixChangeListItemHandler($event, 'images')"
      />
    </v-col>
    <v-row>
      <v-col cols="12">
        <span>Место проведения *</span>
        <LocationAutocomplete
          :address="listItem.data.location"
          :loading="isLoading"
          :error-messages="returnAddressError"
          @set-location="mixChangeListItemHandler($event, 'location')"
          @update-location-part="
            mixChangeListItemHandler($event.value, `location.${$event.fieldName}`)
          "
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import dynamicListItemMix from '@/mixins/dynamic-list/dynamicListItem.mix.js'
import MediaFilePicker from '@/components/media-file-picker/MediaFilePicker.vue'
import LocationAutocomplete from '@/components/location-autocomplete'
import TranslationIcon from '@/components/translation-icon/translationIcon'
import { mediaTypesByKeys } from '@/configs/mediaFileTypes'
import QuillEditorVue from '@/components/quill-editor'

export default {
  name: 'RoutePoint',
  mediaTypesByKeys: mediaTypesByKeys(),
  mixins: [dynamicListItemMix],
  components: {
    TranslationIcon,
    MediaFilePicker,
    LocationAutocomplete,
    QuillEditorVue
  },
  computed: {
    returnAddressError () {
      return this.errorMessages['location.address'] || null
    }
  }
}
</script>
